import { createContext, useState, useContext, useEffect } from "react";

const ConfigContext = createContext();

// Create a provider component
export const ConfigProvider = ({ children }) => {
  const [configOpen, setConfigOpen] = useState(false);
  const [configInitialized, setConfigInitialized] = useState(false);
  const [config, setConfig] = useState({
    botName: "Help Bot",
    botAvatarImage: "./brand/responsum.png",
    chatButtonImage: "./brand/responsum.png",
    color: {
      primary: "#449dff",
      headerBackground: "#27303c",
      headerText: "#fff",
      secondary: "#fff",
      chatButtonIconColor: "#fff",
      chatButtonBackground: "#333e4b",
      avatarBackground: "#333e4b",
      avatarIcon: "#000",
    },
  });

  useEffect(() => {
    if (!config.gtmId) return;

    const gtmId = config.gtmId;

    const script = document.createElement("script");
    script.id = "gtm-script";
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;

    const noscript = document.createElement("noscript");
    noscript.id = "gtm-noscript";
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);

    if (!document.getElementById("gtm-script")) {
      document.head.insertBefore(script, document.head.firstChild);
    }
    if (!document.getElementById("gtm-noscript")) {
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, [config.gtmId]);

  useEffect(() => {
    const widgetConfig = localStorage.getItem("webchat_config");
    if (!widgetConfig) {
      setConfigOpen(true);
      return;
    }
    const widgetConfigJson = JSON.parse(widgetConfig);
    if (widgetConfigJson.hasOwnProperty("configOpen")) {
      setConfigOpen(widgetConfigJson.configOpen);
      setConfigInitialized(true);
    }
  }, []);

  const handleToggleConfigModal = () => {
    setConfigOpen(!configOpen);
    const widgetConfig = localStorage.getItem("webchat_config");
    localStorage.setItem(
      "webchat_config",
      JSON.stringify(
        widgetConfig
          ? { ...JSON.parse(widgetConfig), configOpen: !configOpen }
          : { configOpen: configOpen }
      )
    );
  };

  return (
    <ConfigContext.Provider
      value={{
        config,
        setConfig,
        configOpen,
        setConfigOpen,
        configInitialized,
        setConfigInitialized,
        handleToggleConfigModal,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

// Create a custom hook for easier usage
export const useConfig = () => {
  return useContext(ConfigContext);
};
